import axiosInstance from './axiosInstance'

export const getDisplayPricingNewByQuoteId = (quoteId) => {
  return axiosInstance.get(`/display-pricings-new/by-quote-id/${quoteId}`)
}
